import styled from 'styled-components'
import PageWrapper from 'shared/PageWrapper'

export default styled(PageWrapper)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-template-areas: "nav"
                       "coll";


  overflow: initial;

  margin-bottom: 62px;

  @media (min-width: ${props => props.theme.small}) {
    grid-template-columns: 2fr 8fr;
    grid-template-rows: auto 1fr;
    grid-template-areas: ". head head"
                         "nav coll coll";

    margin-bottom: ${props => props.theme.gutter};

  }

`



// WEBPACK FOOTER //
// ./src/components/SeasonWrapper.js